import { useCallback } from 'react';
import { Colors, Flex, IconChevronRight, Typography } from '@banhala/ui-kit';
import type { InputNonEntryMarketProps } from './types';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';
import { useInputNonEntryMarketBottomSheet } from './useInputNonEntryMarketBottomSheet';

export const InputNonEntryMarket = ({
  entity,
  logging,
}: InputNonEntryMarketProps) => {
  const keyword = entity?.[0]?.item.keyword;
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const { show: showInputNonEntryMarketBottomSheet } =
    useInputNonEntryMarketBottomSheet();

  const handlePress = useCallback(async () => {
    logAnalyticsEvent({
      name: 'CLICK_INPUT_NON_ENTRY_MARKET',
      analytics: { ...logging?.analytics },
      ably_only_log: { ...logging?.ably_only_log },
    });
    await showInputNonEntryMarketBottomSheet({
      searchKeyword: keyword,
      logging,
    });
  }, [logging, keyword, logAnalyticsEvent, showInputNonEntryMarketBottomSheet]);

  return (
    <Flex padding={{ horizontal: 16, vertical: 8 }}>
      <Flex
        backgroundColor="bg_secondary"
        borderRadius={8}
        padding={{ horizontal: 18, vertical: 16 }}
        onPress={handlePress}
      >
        <Flex.Row alignItems="center" justifyContent="space-between">
          <Flex gap={4}>
            <Typography type="body1" color="content_primary">
              혹시 찾고 있는 마켓이 없다면?
            </Typography>
          </Flex>
          <Flex.Row alignItems="center" gap={2}>
            <Typography type="subtitle2" color="content_primary">
              입점 요청하기
            </Typography>
            <IconChevronRight size={16} fill={Colors.content_primary} />
          </Flex.Row>
        </Flex.Row>
      </Flex>
    </Flex>
  );
};
